import { z } from "zod";

export const coFounderExplanationSchema = z.object({
    isFounder: z.boolean().default(false),
    founderWhy: z.string().default(""),
    startedCompanyWhy: z.string().default(""),
});

export type CoFounderExplanation = z.infer<typeof coFounderExplanationSchema>;
